export default {
  appTitle: 'Sync',
  title: 'Osigu Sync - RIPS Premium',
  filterLabel: 'Apply filters',
  resultLabel: 'Results',
  lastUpdateLabel: 'Last update',
  emptyDataLabel: 'No results found',
  tryAgainLabel: 'Try searching another term or ',
  cleanFilters: 'clearing the filters',
  filtersAppliedLabel: ' applied',
  paginationSizeLabel: 'Results per page',
  cleanFilter: 'Clear filters',
  filters: {
    searchCode: 'Search by Document No.',
    branchIdentifiers: 'Branch / Sub-branch',
    status: 'Status',
    invoiceType: 'Invoice/Note Type',
    payerType: 'Payer Type',
    payer: 'Payer',
    agreement: 'Agreement',
    naturalPerson: 'Individual Identification',
    invoiceInitialDate: 'Invoice Initial Date',
    invoiceFinalDate: 'Invoice Final Date',
    dateFilterType: {
      label: 'Filter date by:',
      generation: 'Generation',
      validation: 'Validation'
    },
    confirm: 'Apply filters'
  },
  ripsGrid: {
    status: 'Status',
    invoiceType: 'Invoice/Note Type',
    invoice: 'Invoice/Note',
    reference: 'Reference',
    nit: 'NIT',
    payer: 'Payer',
    agreement: 'Agreement',
    invoiceDate: 'Invoice Date',
    ripsValue: 'RIPS Value',
    netValue: 'Net Value',
    grossValue: 'Gross Value',
    validationDate: 'Validation Date',
    uniqueValidationCode: 'CUV',
    electronicInvoiceUniqueCode: 'CUFE'
  },
  tabs: {
    rips: 'RIPS',
    dashboard: 'Dashboard'
  },
  filtersRequired: 'Missing required fields'
}
